<!-- <style>
th.k-header {
direction: rtl;
}

</style> -->

@if (_columns) {
  @if (withHeader) {
    <div #grid_header_wrapper>
      @if (headerEnable) {
        <asap-grid-layout-header [page]="page" [title]="headerTitle" [importEnable]="importEnable"
          [addNewFormEnabled]="addNewFormEnabled" [deletedEnabled]="deletedEnabled" [graphEnabled]="graphEnabled"
          [groupingEnabled]="groupingEnabled" [exportExcelEnable]="exportExcelEnable" [exportPDFEnable]="exportPDFEnable"
          [exportCSVEnabled]="exportCSVEnabled" [exportWordEnabled]="exportWordEnabled" [searchEnable]="searchEnabled"
          (onSearch)="_onSearch($event)" (refreshButtonClicked)="_refreshButtonClicked($event)"
          (viewActiveInActiveClicked)="_viewActiveInActiveClicked($event)" (activeMode)="GetActiveMode($event)"
          [selectedItems]="_selectedItems" [_inActiveMode]="_inActiveMode"
          [_assetPurchaseOrderStatusValue]="_assetPurchaseOrderStatusValue"
          [_stockPurchaseOrderStatusValue]="_stockPurchaseOrderStatusValue"
          [_stockSalesOrderStatusValue]="_stockSalesOrderStatusValue"
          [_siteTransferStatusValue]="_siteTransferStatusValue"
          [assetReservationItemTypeValue]="assetReservationItemTypeValue" [isAssetReservation]="isAssetReservation"
          [isPerformMaintenance]="isPerformMaintenance" [performMaintenanceItemTypeValue]="performMaintenanceItemTypeValue"
          [disposeAuthorizationStatusValue]="disposeAuthorizationValue" [canReceive]="canBatchReceive"
          [canMove]="canBatchMove" [canDispose]="canBatchDispose" [canIssue]="canBatchIssue"
          [canDeactivate]="canBatchDeactivate" [canActivate]="canBatchActivate" [canReactivate]="canBatchReactivate"
          [canCheckOut]="canBatchCheckOut" [canCheckIn]="canBatchCheckIn" [canApprove]="canBatchApprove"
          [canReject]="canBatchReject" [editColumnsEnabled]="editColumnsEnabled" [reloadDataEnabled]="reloadDataEnabled"
          [_isClosed]="_isClosed" [entityName]="entityName" [_currentUser]="_currentUser" [overridePage]="overridePage"
          [_historyFilterValue]="_historyFilterValue" [isHistoryPage]="isHistoryPage"
          (batchActionClicked)="batchActionClicked.emit($event)">
        </asap-grid-layout-header>
      }
    </div>
  }
  <div #gridWrapper>
    <kendo-grid #grid [ngStyle]="{'max-height.px': _maxHeight}" [data]="_items" [kendoGridSelectBy]="selectByField"
      [selectedKeys]="_selectedKeys" [selectable]="_selectableSettings" [reorderable]="orderEnable"
      [rowClass]="rowCallback" [pageSize]="_state.take" [skip]="_state.skip"
      [pageable]="pagingEnabled ? _pageable : false" [sortable]="sortingEnabled" [sort]="_state.sort"
      [filter]="_state.filter" [filterable]="filteringEnable ? 'menu' : false" [groupable]="_groupingEnabled"
      [group]="_state.group" (dataStateChange)="_dataStateChange($event)"
      [scrollable]="_scrollable ? 'scrollable' : 'none'" (selectedKeysChange)="_onSelectedKeysChange($event,_items)"
      (selectionChange)="_onSelectionChange($event)" (columnReorder)="_onColumnReorder($event)"
      (pageChange)="pageChange($event)" [resizable]="true" (cellClick)="DoubleClickRow($event)">
      @if (selectable) {
        <kendo-grid-checkbox-column [title]="selectByFieldTitle" [resizable]="false"
          [reorderable]="false" [width]="selectByFieldTitle ? 150 : 50" [showSelectAll]="!singleSelect">
        </kendo-grid-checkbox-column>
      }
      @for (column of _columns; track column.field || column.name || $index) {
        @if ((column.type === 'notes' && HideNotesFields == false) && !_currentUser.isEnterprise ) {
          <kendo-grid-column [draggable]="false" [title]="column.name" [width]="60" [reorderable]="true"
            [sortable]="false" [resizable]="true">
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngTemplateOutlet="column.template; context: { $implicit: dataItem }"></ng-container>
            </ng-template>
          </kendo-grid-column>
        }
        @if (column.type != 'command' && column.type!='image' && column.type != 'url' && column.type != 'notes' && column.type != 'date' && column.type != 'number') {
          <kendo-grid-column #columns [field]="column.field" [title]="column.name" [width]="column.width"
            [hidden]="hiddenColumns.indexOf(column) > -1">
            <ng-template *ngIf="_showColumnFilterData(column.field)" kendoGridFilterMenuTemplate let-column="column"
              let-filter="filter" let-filterService="filterService">
              <app-multicheck-filter [isPrimitive]="true" [page]="page" [field]="column.field"
                [filterService]="filterService" [currentFilter]="filter" [isCustomField]="isCustomField(column.field)"
                (dataChecked)="_filterDataChecked($event, column.field)"
                (valueChange)="this._filterStateChange($event)">
              </app-multicheck-filter>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngTemplateOutlet="column.template; context: { $implicit: dataItem }"></ng-container>
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-group let-value="value">
              {{column.name}}:
              @if (column.template) {
                <ng-container *ngTemplateOutlet="column.template; context: { $implicit: getFirstGroupItem(group) }"></ng-container>
              } @else {
                {{ value }}
              }
            </ng-template>
          </kendo-grid-column>
        }
        @if (column.type === 'image') {
          <kendo-grid-column #columns [field]="column.field" [title]="column.name" [width]="column.width"
            [hidden]="hiddenColumns.indexOf(column) > -1" filterable="false">
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngTemplateOutlet="column.template; context: { $implicit: dataItem }"></ng-container>
            </ng-template>
          </kendo-grid-column>
        }
        @if (column.type == 'number') {
          <kendo-grid-column #columns [field]="column.field" [title]="column.name" [width]="column.width"
            filter="numeric" [hidden]="hiddenColumns.indexOf(column) > -1">
            <ng-template *ngIf="_showColumnFilterData(column.field)" kendoGridFilterMenuTemplate let-column="column"
              let-filter="filter" let-filterService="filterService">
              <app-multicheck-filter [isPrimitive]="true" [page]="page" [field]="column.field"
                [filterService]="filterService" [currentFilter]="filter" [isCustomField]="isCustomField(column.field)"
                (dataChecked)="_filterDataChecked($event, column.field)"
                (valueChange)="this._filterStateChange($event)">
              </app-multicheck-filter>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngTemplateOutlet="column.template; context: { $implicit: dataItem }"></ng-container>
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-group let-value="value">
              {{column.name}}:
              @if (column.template) {
                <ng-container *ngTemplateOutlet="column.template; context: { $implicit: getFirstGroupItem(group) }"></ng-container>
              } @else {
                {{ value }}
              }
            </ng-template>
          </kendo-grid-column>
        }
        @if (column.type === 'url') {
          <kendo-grid-column [field]="column.field" [title]="column.name" [width]="column.width">
            <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
              let-filterService="filterService" *ngIf="_showColumnFilterData(column.field)">
              <app-multicheck-filter [isPrimitive]="true" [page]="page" [field]="column.field"
                [filterService]="filterService" [currentFilter]="filter" [isCustomField]="isCustomField(column.field)"
                (dataChecked)="_filterDataChecked($event, column.field)"
                (valueChange)="this._filterStateChange($event)">
              </app-multicheck-filter>
            </ng-template>
            <ng-template kendoGridCellTemplate let-item>
              @if (item[column.field] && item[column.field].startsWith('http')) {
                <a target="_blank"
                [href]="item[column.field]">{{item[column.field]}}</a>
              }
              @if (item[column.field] && !item[column.field].startsWith('http')) {
                <a target="_blank"
                [href]="'http://' + item[column.field]">{{item[column.field]}}</a>
              }
            </ng-template>
          </kendo-grid-column>
        }
        @if (column.type == 'date') {
          <kendo-grid-column #columns [field]="column.field" [title]="column.name" format="MM/dd/yyyy HH:mm"
            filter="date" [width]="column.width" [hidden]="hiddenColumns.indexOf(column) > -1">
            <ng-template *ngIf="_showColumnFilterData(column.field)" kendoGridFilterMenuTemplate let-column="column"
              let-filter="filter" let-filterService="filterService">
              <app-multicheck-filter [isPrimitive]="true" [page]="page" [field]="column.field" [type]="'date'"
                [filterService]="filterService" [currentFilter]="filter" [isCustomField]="isCustomField(column.field)"
                (dataChecked)="_filterDataChecked($event, column.field)"
                (valueChange)="this._filterStateChange($event)">
              </app-multicheck-filter>
            </ng-template>
            <ng-template kendoGridCellTemplate let-dataItem>
              <ng-container *ngTemplateOutlet="column.template; context: { $implicit: dataItem }"></ng-container>
            </ng-template>
            <ng-template kendoGridGroupHeaderTemplate let-group let-value="value">
              {{column.name}}:
              @if (column.template) {
                <ng-container *ngTemplateOutlet="column.template; context: { $implicit: getFirstGroupItem(group) }"></ng-container>
              } @else {
                {{ value }}
              }
            </ng-template>
          </kendo-grid-column>
        }
      }
      @if (_commandColumn != undefined) {
        <kendo-grid-column [title]="_commandColumn?.name || 'Action'" [width]="_commandColumn?.width || 150" [reorderable]="false"
          [sortable]="false" [resizable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <ng-container *ngTemplateOutlet="_commandColumn.template; context: { $implicit: dataItem }"></ng-container>
          </ng-template>
        </kendo-grid-column>
      }
      @if (exportPDFEnable && _pdfColumns && _pdfColumns.length > 0) {
        <kendo-grid-pdf
          [fileName]="exportFileName != 'files' ? exportFileName + '.pdf' : 'pictures.pdf'" paperSize="A4"
          [allPages]="true" [repeatHeaders]="true" [landscape]="true" [scale]="0.5">
          <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm">
          </kendo-grid-pdf-margin>
          @for (item of _pdfColumns; track item.field || item.name || $index) {
            <kendo-grid-column [title]="item.name" [field]="item.field">
            </kendo-grid-column>
          }
        </kendo-grid-pdf>
      }
      <ng-template kendoGridNoRecordsTemplate>
        No data found.
      </ng-template>
    </kendo-grid>
  </div>
}